import { render, staticRenderFns } from "./rgtx.vue?vue&type=template&id=3b885b2a&scoped=true"
import script from "./rgtx.vue?vue&type=script&lang=js"
export * from "./rgtx.vue?vue&type=script&lang=js"
import style0 from "./rgtx.vue?vue&type=style&index=0&id=3b885b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b885b2a",
  null
  
)

export default component.exports